export default function () {
    return {
        require: 'ngModel',
        link: function (scope, element) {
            element.bind('keypress', function (event) {
                const ENTER = 13;
                const keyCode = event.keyCode || event.charCode;
                if (event.target.value.length >= 1 && keyCode !== ENTER) {
                    event.preventDefault();
                }
            });
        }
    };
};